// extracted by mini-css-extract-plugin
export default {"image":"ClipboardButton_image__kNbl4","active":"ClipboardButton_active__InXVU"};